enum ApplicationEmailsActionsEnum {
    ApplicationEmailsList = 'APPLICATION/EMAILS/LIST',
    ApplicationEmailsSet = 'APPLICATION/EMAILS/SET',
    ApplicationEmailTextGet = 'APPLICATION_EMAIL/TEXT/GET',
    ApplicationEmailTextSet = 'APPLICATION_EMAIL/TEXT/SET',
}

export default ApplicationEmailsActionsEnum;
